import {Component, Input, OnInit} from "@angular/core";
import {Stock} from "../../../../shared/view-model/stock";

@Component({
  selector: 'vb-stock-item-details',
  templateUrl: './stock-item-details.component.html',
  styleUrls: ['./stock-item-details.component.css']
})
export class StockItemDetailsComponent implements OnInit {

  @Input()
  stock: Stock;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/stock-detail/stock-item-details/stock-item-details.component.ts